import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';

interface AgentHeaderProps {
    collapsed: boolean;
    setCollapsed: (collapsed: boolean) => void;
    mobileShow: boolean;
    setMobileShow: (show: boolean) => void;
}

const AgentHeaderTop: React.FC<AgentHeaderProps> = ({ collapsed, setCollapsed, mobileShow, setMobileShow }) => {
    const { user } = useAuth();

    return (
        <header className="agent-header shadow-sm">
            <div className="header-left">
                <div className="toggle-sidebar d-none d-lg-block" onClick={() => setCollapsed(!collapsed)}>
                    <i className={`fa-solid ${collapsed ? 'fa-bars-staggered' : 'fa-bars'}`}></i>
                </div>
                <div className="toggle-sidebar d-lg-none" onClick={() => setMobileShow(true)}>
                    <i className="fa-solid fa-bars"></i>
                </div>
                <div className="ms-3 d-none d-md-block">
                    <h5 className="mb-0 fw-bold text-dark">Agent Control Panel</h5>
                </div>
            </div>

            <div className="header-right d-flex align-items-center gap-4">
                <Link to="/" className="text-muted text-decoration-none small fw-medium d-none d-sm-block">
                    <i className="fa-solid fa-house me-1"></i> Visit Website
                </Link>

                <div className="admin-user-nav">
                    <div className="text-end d-none d-sm-block">
                        <div className="fw-bold text-dark lh-1 small">{user?.name}</div>
                        <small className="text-success fw-bold uppercase" style={{ fontSize: '10px' }}>Verified Agent</small>
                    </div>
                    <div className="rounded-circle bg-success shadow-sm d-flex align-items-center justify-content-center text-white fw-bold"
                        style={{ width: 40, height: 40, fontSize: '16px' }}>
                        {user?.name?.charAt(0).toUpperCase()}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default AgentHeaderTop;
